<template>
	<div>
		<div class="offcanvas-header d-flex justify-content-between align-items-center">
			<h3 class="offcanvas-title">Поиск по сайту</h3>
			<button class="close" type="button" data-dismiss="offcanvas" aria-label="Close"><span aria-hidden="true">&times;</span></button>
		</div>
		<div class="offcanvas-body">
			<div class="offcanvas-body-inner">
				<div class="input-group pt-3">
					<autocomplete :search="search"
								  placeholder="Введите фразу"
								  aria-label="Введите фразу"
								  :get-result-value="getResultValue"
								  v-on:submit="handleSubmit">
						<template #result="{ result, props }">
							<li v-bind="props"
								class="autocomplete-result search-result">
								<div class="search-result-title">
									{{ result.name }} <span :class="result.badgeCssClass">{{result.type}}</span>
								</div>
								<div class="search-result-snippet" v-html="result.snippet"></div>
							</li>
						</template>
					</autocomplete>
				</div><small class="form-text pt-1">Начните набирать текст, появятся подсказки.</small>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "Vue";
	import Autocomplete from "@trevoreyre/autocomplete-vue";
	import "@trevoreyre/autocomplete-vue/dist/style.css";
	import autocompleteMixin from "Mixin/autocomplete";

	Vue.use(Autocomplete);

	export default {
		name: "search-widget",
		mixins: [autocompleteMixin],
		components: {
			Autocomplete
		}
	}
</script>